const newLocal = 'https://api.safehandsdiagnostics.in/api/v1';
// eslint-disable-next-line
export default {
  apiBaseUrl: newLocal,
  googleApiKey: 'AIzaSyDPjxweawqnUZSa53x4U0RtY_q1yn3HLEo',
}
